import React, { useContext, useEffect, useState, useRef } from "react";
import "./PlanningList.css";
import DevicesConst from "../constants/Devices";
import WarningAlert from "./sweeAlerts/WarningAlert";
import { MqttContext } from "../context/MQTTContext";
import { Context } from "../context/Context";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const PlanningList = () => {
  const { setIsLoading, devices, setDevices } = useContext(Context);
  const { clients } = useContext(MqttContext);

  const [plannings, setPlannings] = useState({});
  const [commands, setCommands] = useState({});
  
  // استفاده از ref برای نگهداری لیسنرها
  const listenersRef = useRef([]);

  useEffect(() => {
    // تابع برای ثبت لیسنرها
    const registerListeners = () => {
      // پاک کردن لیسنرهای قبلی
      cleanupListeners();
      
      const newListeners = [];

      if (devices.length) {
        devices.forEach((device) => {
          if (
            device.is_bus == 1 &&
            device.bridge_device &&
            clients[device?.bridge_device?.id]
          ) {
            const messageListener = (topic, message) => {
              const endOfTwoCharToken =
                String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
              const deviceSerial =
                String.fromCharCode(message[3]) +
                String.fromCharCode(message[4]) +
                String.fromCharCode(message[5]) +
                String.fromCharCode(message[6]) +
                String.fromCharCode(message[7]) +
                String.fromCharCode(message[8]);
              if (
                device.bridge_device.internet_token.slice(-2) ===
                  endOfTwoCharToken &&
                device.serial === deviceSerial &&
                message[10] == 6 &&
                message[2] == 14
              ) {
                setPlannings((prev) => ({
                  ...prev,
                  [device.id]: message.slice(11),
                }));
              }
            };
            
            // ثبت لیسنر و ذخیره اطلاعات برای cleanup
            clients[device.bridge_device.id].on("message", messageListener);
            newListeners.push({
              client: clients[device.bridge_device.id],
              listener: messageListener,
              event: "message"
            });

            // ارسال درخواست
            let buffer = new ArrayBuffer(10);
            let asciiCode = new Uint8Array(buffer);
            asciiCode[0] = 14;
            asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
            asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
            asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
            asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
            asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
            asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
            asciiCode[7] = device.type + 50;
            asciiCode[8] = 3;
            asciiCode[9] = 1;

            let message = device.bridge_device.internet_token;
            let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
            clients[device.bridge_device.id].publish(
              device.bridge_device.serial + "/sys",
              combinedMessage,
            );
          }
          
          if (device.is_bus == 0 && clients[device.id]) {
            const messageListener = (topic, message) => {
              const endOfTwoCharToken =
                String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
              if (
                device.internet_token.slice(-2) === endOfTwoCharToken &&
                message[2] == 6
              ) {
                setPlannings((prev) => ({
                  ...prev,
                  [device.id]: message.slice(3),
                }));
              }
            };
            
            // ثبت لیسنر و ذخیره اطلاعات برای cleanup
            clients[device.id].on("message", messageListener);
            newListeners.push({
              client: clients[device.id],
              listener: messageListener,
              event: "message"
            });

            // ارسال درخواست
            const decimalArray = [3, 1];
            const asciiArray = decimalArray.map((num) =>
              String.fromCharCode(num),
            );
            clients[device.id].publish(
              device.serial + "/sys",
              device.internet_token + asciiArray.join(""),
            );
          }
        });
      }
      
      // ذخیره لیسنرهای جدید
      listenersRef.current = newListeners;
    };

    // تابع پاک‌سازی لیسنرها
    const cleanupListeners = () => {
      listenersRef.current.forEach(({ client, listener, event }) => {
        if (client && client.off) {
          client.off(event, listener);
        }
      });
      listenersRef.current = [];
    };

    // ثبت لیسنرها
    registerListeners();

    // تابع cleanup برای زمان unmount
    return cleanupListeners;
  }, [devices, clients]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str);

    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    newBuffer.set(encodedString, 0);
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleRemoveSchedule = (device, scheduleCode) => {
    WarningAlert(
      "آیا از حذف این برنامه اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        if (
          device.is_bus == 1 &&
          device.bridge_device &&
          clients[device?.bridge_device?.id]
        ) {
          let buffer = new ArrayBuffer(10);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          asciiCode[8] = 2;
          asciiCode[9] = scheduleCode;

          let message = device.bridge_device.internet_token;
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
        } else if (device.is_bus == 0 && clients[device.id]) {
          const decimalArray = [2, scheduleCode];
          const asciiArray = decimalArray.map((num) =>
            String.fromCharCode(num),
          );
          clients[device.id].publish(
            device.serial + "/sys",
            device.internet_token + asciiArray.join(""),
          );
        }
      }
    });
  };

  const commandLength = 34;
  const renderCommands = () => {
    const commandElements = [];

    for (const device_id in plannings) {
      const numberOfCommands = plannings[device_id][0];

      for (let j = 0; j < numberOfCommands; j++) {
        const startIdx = 1 + j * commandLength;
        const endIdx = startIdx + commandLength;

        const commandData = plannings[device_id].slice(startIdx, endIdx);
        const device = devices.find((dev) => dev.id == device_id);
        if (!device) {
          return;
        }
        const scheduleName = new Uint8Array(commandData.slice(4));
        const decoder = new TextDecoder("utf-8");
        const decodedScheduleName = decoder.decode(scheduleName);
        commandElements.push(
          <div
            className="col-12 col-md-6 col-lg-4 device-list-item"
            key={`${device_id}-${j}`}
          >
            <div className="card mb-4 py-3 px-2">
              <div className="card-body position-relative">
                <button
                  type="button"
                  className="btn rounded-pill btn-icon position-absolute text-danger"
                  style={{ top: "0", right: "3px" }}
                  onClick={() => handleRemoveSchedule(device, commandData[3])}
                >
                  <span className="tf-icons bx bx-trash"></span>
                </button>
                <div className="d-flex flex-wrap justify-content-between">
                  <div className="align-self-center">
                    <div>
                      <span dir="ltr" className="fw-bold fs-3">
                        {String(commandData[0]).padStart(2, "0")}:
                        {String(commandData[1]).padStart(2, "0")}
                      </span>
                      <span dir="ltr" className="mx-3">
                        {" "}
                        {decodedScheduleName}
                      </span>
                    </div>
                    {commandData[2].toString(2).padStart(8, "0") ===
                    "00000000" ? (
                      <div>
                        <span className="text-success">فقط یک بار</span>
                      </div>
                    ) : (
                      <div>
                        <span
                          className={
                            commandData[2]
                              .toString(2)
                              .padStart(8, "0")
                              .split("")
                              .reverse()
                              .join("")[0] === "1"
                              ? "text-success"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          ش
                        </span>
                        <span
                          className={
                            commandData[2]
                              .toString(2)
                              .padStart(8, "0")
                              .split("")
                              .reverse()
                              .join("")[1] === "1"
                              ? "text-success"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          ی
                        </span>
                        <span
                          className={
                            commandData[2]
                              .toString(2)
                              .padStart(8, "0")
                              .split("")
                              .reverse()
                              .join("")[2] === "1"
                              ? "text-success"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          د
                        </span>
                        <span
                          className={
                            commandData[2]
                              .toString(2)
                              .padStart(8, "0")
                              .split("")
                              .reverse()
                              .join("")[3] === "1"
                              ? "text-success"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          س
                        </span>
                        <span
                          className={
                            commandData[2]
                              .toString(2)
                              .padStart(8, "0")
                              .split("")
                              .reverse()
                              .join("")[4] === "1"
                              ? "text-success"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          چ
                        </span>
                        <span
                          className={
                            commandData[2]
                              .toString(2)
                              .padStart(8, "0")
                              .split("")
                              .reverse()
                              .join("")[5] === "1"
                              ? "text-success"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          پ
                        </span>
                        <span
                          className={
                            commandData[2]
                              .toString(2)
                              .padStart(8, "0")
                              .split("")
                              .reverse()
                              .join("")[6] === "1"
                              ? "text-success"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          ج
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="schedule-img align-self-center">
                    <img
                      src={
                        DevicesConst.find((dev) => dev.type == device?.type)
                          ?.img_path
                      }
                      alt=""
                    />
                    <div className="device-info text-center">
                      <span>
                        {DevicesConst.find((d) => d.type == device?.type)
                          ?.prefix +
                          "-" +
                          device?.serial}
                        <br />
                        {device?.name ? device.name : ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>,
        );
      }
    }

    return <>{commandElements}</>;
  };

  return (
    <div className="row mt-2 mx-0">{renderCommands()}</div>
  );
};

export default PlanningList;